<template>
  <div>
    <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 20}" v-model="orderList" placeholder="请输入订单号" />
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" size="medium">关闭</el-button>
      <el-button type="primary" size="medium" @click.native="submit" v-loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from '@/api/api';
import { uploadAbnormalOrders } from '@/api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      orderList: '',
      submitLoading: false
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },

    submit() {
      if(!this.orderList) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "订单号不能都为空",
          type: 'warning'
        });
        return;
      }
      this.submitLoading = true;
      let list = this.orderList.replace(/[\n\r]/g,',').replace(/\s*/g, '');
      let param = {};
      param['abnormalOrders'] = list.split(',');
      postFormData(uploadAbnormalOrders, param).then((data) => {
        let {code,msg} = data;
        if(code == 200){
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm');
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.submitLoading = false;
      })
          .catch(function(response){
            this.submitLoading = false;
          })
    }
  },
  mounted() {

  }
}
</script>

<style>

</style>
